import {
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from './get-locale'

const BILINGUAL_LOCALES = ['it', 'en'] as const satisfies readonly SupportedLocale[]

const SITE_LOCALES = new Map<string, readonly SupportedLocale[]>([
  ['siad-com', SUPPORTED_LOCALES],
  ['siad-engineering', BILINGUAL_LOCALES],
])

export function getSiteLocales(
  siteName?: string
): readonly SupportedLocale[] {
  if (siteName?.startsWith('thesiadgroup')) {
    return BILINGUAL_LOCALES
  }

  return SITE_LOCALES.get(siteName ?? '') ?? SUPPORTED_LOCALES
}
